import React from "react";
import { useDispatch } from "react-redux";
import { goToRoute } from "../../Utils/goToRoute";
import { requestCallback, toggleRequestCallbackModal } from "../../Redux/Actions";
import { SUBSCRIPTION_RENEWAL } from "../../Constants/routesConstant";
import { CTAButton } from "..";
import clsx from "clsx";
import { isSubscriptionExpiring } from "../../Utils/subscription";
import { useSubscriptionDetailsSuite } from "../../Hooks/useSubscriptionDetailsSuite";

interface IFooterProps {
  className?: string;
  buttonLarge?: boolean;
  afterRenewCallback?: () => void;
  beforeShowOffers?: () => void;
  subscriptionStatus?: Record<string, boolean | number>;
}

export const SubscriptionExpiryFooter = (props: IFooterProps) => {
  const { className = "", buttonLarge = false, afterRenewCallback, beforeShowOffers } = props;
  const dispatch = useDispatch();
  const { renewLater, subscriptionStatus } = useSubscriptionDetailsSuite();

  const requestACallback = () => {
    dispatch(
      requestCallback({ text: "renew_ecomm_pack", feature_name: "renew_ecomm_pack" }, () => {
        afterRenewCallback?.();
        setTimeout(() => dispatch(toggleRequestCallbackModal(true)), 350);
      }),
    );
  };

  const showOffers = () => {
    beforeShowOffers?.();
    goToRoute(SUBSCRIPTION_RENEWAL);
  };

  return (
    <div className={clsx("flex items-center justify-end ds-mt24", className)}>
      <CTAButton
        text={subscriptionStatus.isExpired ? "Request a Callback" : "I'll do it later"}
        customStyles={{
          fontSize: 13,
          color: "#3D6AFD",
          backgroundColor: "#fff",
          padding: buttonLarge ? "12px" : "6px",
          borderRadius: 6,
          marginRight: "16px",
          border: "0.8px solid #E6E6EB",
          width: "auto",
          boxShadow: "none",
        }}
        onClick={subscriptionStatus.isExpired ? requestACallback : renewLater}
      />
      <CTAButton
        text="Renew Now"
        customStyles={{
          fontSize: 13,
          backgroundColor: "#3D6AFD",
          color: "#fff",
          padding: buttonLarge ? "12px" : "6px",
          borderRadius: 6,
          border: "none",
          width: "auto",
          boxShadow: "none",
        }}
        onClick={showOffers}
      />
    </div>
  );
};
